/**
 * Константы приложения — перенос shared/src/commonMain/kotlin/CommonVars.kt (1:1 по значениям).
 *
 * Значения менять нельзя: они входят в контракт URL, полей JSON и имён переменных окружения
 * (см. TRANSFER-PLAN.md §2). Соответствие «константа → где используется» — CONSTANTS.md.
 */

// --- маршруты и протокол ---
export const HTTP = 'http';
export const ROUTE_BD = 'bd';
export const JSON_PG = 'jsonPG';
export const JSON_PG_UPD = 'jsonPGupd';
export const PASSW = 'passw';
export const LOADENV = 'loadEnv';
/** Значение по умолчанию для переменной окружения SERVER_TYPE. */
export const SERVER_TYPE = 'https';
/** Подставляется сервером вместо плейсхолдера в index.html при SERVER_TYPE=https. */
export const META_SECURITY =
  "<meta http-equiv='Content-Security-Policy' content='upgrade-insecure-requests'>";

// --- имена базы и списка запросов ---
export const QUERY_BD = 'QUERY_BD';
export const VIEW_QUERY = 'v_querys';
export const VIEW_QUERY_NAME = 'v';
export const VIEW_QUERY_WHERE = 'w';
export const VIEW_QUERY_WHERE_DEFAULT = " and left(name,2)!='--'";
export const SUBMENU = 'submenu';
export const CONSTRUCTION = 'Construction';

// --- параметры URL фронтенда ---
export const FIRSTQUERY = 'q';
export const ENDPOINT_SERVICE_URL = 'b';
export const ROW_FIELDS_VALUE_PARAM = 'rFV';

// --- состояние интерфейса ---
export const HIDE = 'hide';
export const SHOW = 'show';
export const EDIT_YES = 'edit_yes';
export const EDIT_NO = 'edit_no';
export const NEW_TAB = '*';
export const OPEN_IN_NEW_TAB = 'Open in New Tab';

// --- тексты интерфейса ---
export const TRYING_TO_SAVE = 'Trying to save... ';
export const TRYING_TO_FETCH = 'Trying to fetch... ';
export const ERROR_IN_FETCH = 'ERROR in fetch FOR ';
export const UPDATE_BASE_SUCCESS = 'Update Success !!!';
export const UPDATE_BASE_ERROR = 'Update Error !!!';
export const NOT_FOUND_QUERY_NAME = 'NOT fount query name';
export const SAVE_TO_SERVER = " 'SAVE to server ??'";
export const URI_FOR_QUERY = ' Uri for query OR name query: ';
export const TITLES_FOR_QUERY = ' Title for query';
export const ADMIN_PASSW = 'Admin passw';
/** Ключ ошибки внутри JSON-строки ответа (с кавычками — так его ищут в тексте). */
export const ERROR_FIELD = '"error"';

// --- SQL ---
export const QUOTE_ONE = "'";
export const QUOTE_THREE = '"""';
/** SQLSTATE, при которых соединение считается разорванным и его нужно пересоздать. */
export const SQL_STATE_RETRY = '08003,08006,57P01';
export const SQL_STATE_RETRY_LIST: readonly string[] = SQL_STATE_RETRY.split(',');

// --- даты ---
export const DATE_FROM = '@dateFrom';
export const DATE_TO = '@dateTo';
export const DATE_MIN = '2015-01-01';
export const DATE_MAX = '2027-12-31';

// --- прочее ---
export const GIT_VERSION = 'git.version';
export const LOAD_TESTING_KEYS = 'LOAD_TESTING_KEYS';

// --- удалено по решению (TRANSFER-PLAN.md §4.3, §8) ---
// JSR223 ('jsr223') — маршрут POST /jsr223 и обработчик F9 убраны вместе с env-переменной.
// NOT_JSON_CHAR ('') — использовалась только мёртвыми encodeJson/decodeJson, которые были
//   тождественными функциями; в TS-версии удалены вместе с вызовами.
